export enum EPaymentConfigModeType {
	upi = 'upi',
	cards = 'cards',
	netbanking = 'netbanking',
	wallet = 'wallet'
}

export enum EPayoutModeType {
	UPI = 'UPI',
	BANK = 'BANK'
}

export enum EFeatureType {
	PAYOUT = 'payout',
	CHECKOUT = 'checkout'
}

export enum EUpiPaymentConfigInstrumentTypes {
	PHONE_PE = 'PhonePe',
	PAYTM_UPI = 'Paytm',
	GOOGLE_PAY = 'GPay',
	AMAZONE_PAY = 'AmazonPay',
	BHIM = 'Bhim',
	AIRTEL = 'Airtel',
	CRED = 'CRED'
}

export enum EWalletPaymentConfigInstrumentTypes {
	FREECHARGE = 'FREECHARGE',
	PHONEPE = 'PHONEPE',
	AMAZONPAY = 'AMAZONPAY',
	OLAMONEY = 'OLAMONEY',
	AIRTELMONEY = 'AIRTELMONEY',
	JIOMONEY = 'JIOMONEY',
	MOBIKWIK = 'MOBIKWIK',
	BAJAJPAY = 'BAJAJPAY'
}

export enum ENetBankingPaymentConfigInstrumentTypes {
	SBI = 'NB_SBI',
	KOTAK = 'NB_KOTAK',
	PNB = 'NB_PNB',
	YESB = 'NB_YESB'
}

export enum PaymentGateway {
	RAZORPAY = 'razorpay',
	CASHFREE = 'cashfree',
	PAYTM = 'paytm',
	JUSPAY = 'juspay',
	MOBIKWIK = 'mobikwik',
	PHONEPE = 'phonepe',
	PAYU = 'payu',
	RAZORPAY_V2 = 'razorpay_v2',
	CASHFREE_ESCROW = 'cashfree_escrow',
	CASHFREE_V2 = 'cashfree_v2',
	CASHFREE_V3 = 'cashfree_v3'
}

export enum ECardType {
	CREDIT = 'CREDIT',
	DEBIT = 'DEBIT'
}

export enum ECardNetworkType {
	MASTERCARD = 'MASTERCARD',
	RUPAY = 'RUPAY',
	VISA = 'VISA',
	AMEX = 'AMEX',
	MAESTRO = 'MAESTRO'
}

export enum EBankIssuerTypes {
	'ABHY' = 'ABHYUDAYA COOPERATIVE BANK LIMITED',
	'ABPB' = 'ADITYA BIRLA IDEA PAYMENTS BANK',
	'ADCB' = 'ABU DHABI COMMERCIAL BANK',
	'ADCC' = 'THE AKOLA DISTRICT CENTRAL COOPERATIVE BANK',
	'AIRP' = 'AIRTEL PAYMENTS BANK LIMITED',
	'AJHC' = 'AMBARNATH JAIHIND COOP BANK LTD AMBARNATH',
	'AKJB' = 'AKOLA JANATA COMMERCIAL COOPERATIVE BANK',
	'ALLA' = 'ALLAHABAD BANK',
	'AMCB' = 'AHMEDABAD MERCANTILE COOPERATIVE BANK',
	'AMDN' = 'AHMEDNAGAR MERCHANTS CO-OP BANK LTD',
	'ANDB' = 'ANDHRA BANK',
	'ANZB' = 'AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED',
	'APBL' = 'THE ANDHRA PRADESH STATE COOPERATIVE BANK LIMITED',
	'APGB' = 'ANDHRA PRAGATHI GRAMEENA BANK',
	'APGV' = 'ANDHRA PRADESH GRAMEENA VIKAS BANK',
	'APMC' = 'THE A.P. MAHESH COOPERATIVE URBAN BANK LIMITED',
	'ASBL' = 'APNA SAHAKARI BANK LIMITED',
	'AUBL' = 'AU SMALL FINANCE BANK LIMITED',
	'AUCB' = 'ALMORA URBAN COOPERATIVE BANK LIMITED',
	'BACB' = 'BASSEIN CATHOLIC COOPERATIVE BANK LIMITED',
	'BARA' = 'THE BARAMATI SAHAKARI BANK LTD',
	'BARB' = 'BANK OF BARODA',
	'BARC' = 'BARCLAYS BANK',
	'BBKM' = 'BANK OF BAHARAIN AND KUWAIT BSC',
	'BCBM' = 'BHARAT COOPERATIVE BANK MUMBAI LIMITED',
	'BCEY' = 'BANK OF CEYLON',
	'BDBL' = 'BANDHAN BANK LIMITED',
	'BKDN' = 'DENA BANK',
	'BKID' = 'BANK OF INDIA',
	'BNPA' = 'B N P PARIBAS',
	'BNSB' = 'BHAGINI NIVEDITA SAHAKARI BANK LTD PUNE',
	'BOFA' = 'BANK OF AMERICA',
	'BOTM' = 'MUFG BANK, LTD',
	'CBIN' = 'CENTRAL BANK OF INDIA',
	'CCBL' = 'CITIZEN CREDIT COOPERATIVE BANK LIMITED',
	'CHAS' = 'JP MORGAN BANK',
	'CITI' = 'CITI BANK',
	'CIUB' = 'CITY UNION BANK LIMITED',
	'CLBL' = 'CAPITAL SMALL FINANCE BANK LIMITED',
	'CNRB' = 'CANARA BANK',
	'CORP' = 'CORPORATION BANK',
	'COSB' = 'THE COSMOS CO OPERATIVE BANK LIMITED',
	'CRES' = 'CREDIT SUISEE AG',
	'CRLY' = 'CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK CALYON BANK',
	'CRUB' = 'SHRI CHHATRAPATI RAJASHRI SHAHU URBAN COOPERATIVE BANK LIMITED',
	'CSBK' = 'CSB BANK LIMITED',
	'CTCB' = 'CHINATRUST COMMERCIAL BANK LIMITED',
	'DBSS' = 'DBS BANK INDIA LIMITED',
	'DCBL' = 'DCB BANK LIMITED',
	'DEOB' = 'DEOGIRI NAGARI SAHAKARI BANK LTD. AURANGABAD',
	'DEUT' = 'DEUSTCHE BANK',
	'DICG' = 'DEPOSIT INSURANCE AND CREDIT GUARANTEE CORPORATION',
	'DLSC' = 'THE DELHI STATE COOPERATIVE BANK LIMITED',
	'DLXB' = 'DHANALAKSHMI BANK',
	'DMKJ' = 'DMK JAOLI BANK',
	'DNSB' = 'DOMBIVLI NAGARI SAHAKARI BANK LIMITED',
	'DOHB' = 'DOHA BANK',
	'DURG' = 'DURGAPUR STEEL PEOPLES CO-OPERATIVE BANK LTD',
	'EBIL' = 'EMIRATES NBD BANK P J S C',
	'EIBI' = 'EXPORT IMPORT BANK OF INDIA',
	'ESFB' = 'EQUITAS SMALL FINANCE BANK LIMITED',
	'ESMF' = 'ESAF SMALL FINANCE BANK LIMITED',
	'FDRL' = 'FEDERAL BANK',
	'FINO' = 'FINO PAYMENTS BANK',
	'FIRN' = 'FIRSTRAND BANK LIMITED',
	'FSFB' = 'FINCARE SMALL FINANCE BANK LTD',
	'GBCB' = 'THE GREATER BOMBAY COOPERATIVE BANK LIMITED',
	'GDCB' = 'THE GADCHIROLI DISTRICT CENTRAL COOPERATIVE BANK LIMITED',
	'GSCB' = 'THE GUJARAT STATE COOPERATIVE BANK LIMITED',
	'HARC' = 'HARYANA STATE COOPERATIVE BANK',
	'HCBL' = 'THE HASTI COOP BANK LTD',
	'HDFC' = 'HDFC BANK',
	'HPSC' = 'HIMACHAL PRADESH STATE COOPERATIVE BANK LTD',
	'HSBC' = 'HSBC BANK',
	'HVBK' = 'WOORI BANK',
	'IBBK' = 'PT BANK MAYBANK INDONESIA TBK',
	'IBKL' = 'IDBI BANK',
	'IBKO' = 'INDUSTRIAL BANK OF KOREA',
	'ICBK' = 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED',
	'ICIC' = 'ICICI BANK LIMITED',
	'IDFB' = 'IDFC FIRST BANK LTD',
	'IDIB' = 'INDIAN BANK',
	'IDUK' = 'IDUKKI DISTRICT CO OPERATIVE BANK LTD',
	'IFSC' = 'BANK',
	'INDB' = 'INDUSIND BANK',
	'IOBA' = 'INDIAN OVERSEAS BANK',
	'IPOS' = 'INDIA POST PAYMENT BANK',
	'ITBL' = 'Irinjalakuda Town Co-Operative Bank Ltd',
	'JAKA' = 'JAMMU AND KASHMIR BANK LIMITED',
	'JANA' = 'JANASEVA SAHAKARI BANK LIMITED',
	'JASB' = 'JANASEVA SAHAKARI BANK BORIVLI LIMITED',
	'JIOP' = 'JIO PAYMENTS BANK LIMITED',
	'JJSB' = 'JALGAON JANATA SAHAKARI BANK LIMITED',
	'JPCB' = 'THE JALGAON PEOPELS COOPERATIVE BANK LIMITED',
	'JSBL' = 'JANAKALYAN SAHAKARI BANK LIMITED',
	'JSBP' = 'JANATA SAHAKARI BANK LIMITED',
	'JSFB' = 'JANA SMALL FINANCE BANK LTD',
	'KACE' = 'THE KANGRA CENTRAL COOPERATIVE BANK LIMITED',
	'KAIJ' = 'KALLAPPANNA AWADE ICHALKARANJI JANATA SAHAKARI BANK LIMITED',
	'KANG' = 'THE KANGRA COOPERATIVE BANK LIMITED',
	'KARB' = 'KARNATAKA BANK LIMITED',
	'KCCB' = 'KALUPUR COMMERCIAL COOPERATIVE BANK',
	'KDCB' = 'KOZHIKODE DISTRICT COOPERATIAVE BANK LTD',
	'KGRB' = 'KAVERI GRAMEENA BANK',
	'KJSB' = 'KALYAN JANATA SAHAKARI BANK',
	'KKBK' = 'KOTAK MAHINDRA BANK LIMITED',
	'KLGB' = 'KERALA GRAMIN BANK',
	'KNSB' = 'THE KURMANCHAL NAGAR SAHAKARI BANK LIMITED',
	'KOEX' = 'KEB Hana Bank',
	'KRTH' = 'KRUNG THAI BANK PCL',
	'KSBK' = 'The Kerala State Co Operative Bank Ltd',
	'KSCB' = 'THE KARANATAKA STATE COOPERATIVE APEX BANK LIMITED',
	'KUCB' = 'THE KARAD URBAN COOPERATIVE BANK LIMITED',
	'KVBL' = 'KARUR VYSYA BANK',
	'KVGB' = 'KARNATAKA VIKAS GRAMEENA BANK',
	'LAVB' = 'LAXMI VILAS BANK',
	'MAHB' = 'BANK OF MAHARASHTRA',
	'MAHG' = 'Maharashtra Gramin Bank',
	'MCBL' = 'GS Mahanagar Co-operative Bank Limited, Mumbai',
	'MDCB' = 'THE MUMBAI DISTRICT CENTRAL COOPERATIVE BANK LIMITED',
	'MHCB' = 'MIZUHO BANK LTD',
	'MSBL' = 'Mahesh Sahakari Bank Ltd Pune',
	'MSCI' = 'MAHARASHTRA STATE COOPERATIVE BANK',
	'MSHQ' = 'MASHREQBANK PSC',
	'MSNU' = 'THE MEHSANA URBAN COOPERATIVE BANK',
	'MUBL' = 'THE MUNICIPAL COOPERATIVE BANK LIMITED',
	'MVCB' = 'SIR M VISVESVARAYA CO OPERATIVE BANK LTD',
	'NBAD' = 'FIRST ABU DHABI BANK PJSC',
	'NBRD' = 'NATIONAL BANK FOR AGRICULTURE AND RURAL DEVELOPMENT',
	'NCUB' = 'THE NILAMBUR CO OPERATIVE URBAN BANK LTD NILAMBUR',
	'NESF' = 'NORTH EAST SMALL FINANCE BANK LIMITED',
	'NGSB' = 'NAGPUR NAGARIK SAHAKARI BANK LIMITED',
	'NICB' = 'NEW INDIA COOPERATIVE BANK LIMITED',
	'NJBK' = 'NAV JEEVAN CO OP BANK LTD',
	'NKGS' = 'NKGSB COOPERATIVE BANK LIMITED',
	'NMCB' = 'THE NASIK MERCHANTS COOPERATIVE BANK LIMITED',
	'NNSB' = 'NUTAN NAGARIK SAHAKARI BANK LIMITED',
	'NOSC' = 'THE BANK OF NOVA SCOTIA',
	'NSPB' = 'NSDL Payments Bank Limited',
	'NTBL' = 'THE NAINITAL BANK LIMITED',
	'NUCB' = 'NAGAR URBAN CO OPERATIVE BANK',
	'NVNM' = 'THE NAVNIRMAN CO-OPERATIVE BANK LIMITED',
	'ORBC' = 'ORIENTAL BANK OF COMMERCE',
	'PJSB' = 'G P PARSIK BANK',
	'PKGB' = 'PRAGATHI KRISHNA GRAMIN BANK',
	'PMCB' = 'PUNJAB AND MAHARSHTRA COOPERATIVE BANK',
	'PMEC' = 'PRIME COOPERATIVE BANK LIMITED',
	'PRTH' = 'PRATHAMA BANK',
	'PSIB' = 'PUNJAB AND SIND BANK',
	'PUCB' = 'THE PANDHARPUR URBAN CO OP. BANK LTD. PANDHARPUR',
	'PUNB' = 'PUNJAB NATIONAL BANK',
	'PYTM' = 'PAYTM PAYMENTS BANK LTD',
	'QNBA' = 'QATAR NATIONAL BANK SAQ',
	'RABO' = 'RABOBANK INTERNATIONAL',
	'RATN' = 'RBL BANK LIMITED',
	'RBIH' = 'IDRBT',
	'RBIS' = 'RESERVE BANK OF INDIA',
	'RMGB' = 'RAJASTHAN MARUDHARA GRAMIN BANK',
	'RNSB' = 'RAJKOT NAGRIK SAHAKARI BANK LIMITED',
	'RRBP' = 'RAJARAMBAPU SAHAKARI BANK LIMITED',
	'RSBL' = 'RAJGURUNAGAR SAHAKARI BANK LIMITED',
	'RSCB' = 'THE RAJASTHAN STATE COOPERATIVE BANK LIMITED',
	'SABR' = 'SBER BANK',
	'SAHE' = 'SAHEBRAO DESHMUKH COOPERATIVE BANK LIMITED',
	'SANT' = 'SANT SOPANKAKA SAHAKARI BANK LTD',
	'SBIN' = 'STATE BANK OF INDIA',
	'SBLS' = 'SAMARTH SAHAKARI BANK LTD',
	'SCBL' = 'STANDARD CHARTERED BANK',
	'SDCB' = 'THE SURAT DISTRICT COOPERATIVE BANK LIMITED',
	'SHBK' = 'SHINHAN BANK',
	'SIBL' = 'SOUTH INDIAN BANK',
	'SIDC' = 'THE SINDHUDURG DISTRICT CENTRAL COOP BANK LTD',
	'SJSB' = 'SOLAPUR JANATA SAHAKARI BANK LIMITED',
	'SKSB' = 'SHIKSHAK SAHAKARI BANK LIMITED',
	'SMBC' = 'SUMITOMO MITSUI BANKING CORPORATION',
	'SMCB' = 'SHIVALIK MERCANTILE CO OPERATIVE BANK LTD',
	'SNBK' = 'Saraspur Nagrik Co operative Bank Ltd Saraspur',
	'SOGE' = 'SOCIETE GENERALE',
	'SPCB' = 'THE SURATH PEOPLES COOPERATIVE BANK LIMITED',
	'SRCB' = 'SARASWAT COOPERATIVE BANK LIMITED',
	'STCB' = 'SBM BANK INDIA LIMITED',
	'SUNB' = 'SURAT NATIONAL COOPERATIVE BANK LIMITED',
	'SURY' = 'SURYODAY SMALL FINANCE BANK LIMITED',
	'SUTB' = 'SUTEX COOPERATIVE BANK LIMITED',
	'SVBL' = 'THE SEVA VIKAS COOPERATIVE BANK LIMITED',
	'SVCB' = 'THE SHAMRAO VITHAL COOPERATIVE BANK',
	'SVSH' = 'Shri Veershaiv Co Op Bank Ltd',
	'SYNB' = 'SYNDICATE BANK',
	'TBSB' = 'THE THANE BHARAT SAHAKARI BANK LIMITED',
	'TDCB' = 'THE THANE DISTRICT CENTRAL COOPERATIVE BANK LIMITED',
	'TGMB' = 'TUMKUR GRAIN MERCHANTS COOPERATIVE BANK LIMITED',
	'THRS' = 'THRISSUR DISTRICT CO-OPERATIVE BANK LTD',
	'TJSB' = 'TJSB SAHAKARI BANK LTD',
	'TMBL' = 'TAMILNAD MERCANTILE BANK LIMITED',
	'TNSC' = 'THE TAMIL NADU STATE APEX COOPERATIVE BANK',
	'TSAB' = 'TELANGANA STATE COOP APEX BANK',
	'TTCB' = 'TEXTILE TRADERS CO OPERATIVE BANK LTD',
	'UBIN' = 'UNION BANK OF INDIA',
	'UCBA' = 'UCO BANK',
	'UJVN' = 'Ujjivan Small Finance Bank Limited',
	'UOVB' = 'UNITED OVERSEAS BANK LIMITED',
	'URBN' = 'THE URBAN CO OPERATIVE BANK Ltd No ONE SEVEN FIVE EIGHT PERINTHALMANNA',
	'UTBI' = 'UNITED BANK OF INDIA',
	'UTIB' = 'AXIS BANK',
	'UTKS' = 'UTKARSH SMALL FINANCE BANK',
	'VARA' = 'THE VARACHHA COOPERATIVE BANK LIMITED',
	'VASJ' = 'VASAI JANATA SAHAKARI BANK LTD',
	'VCOB' = 'The Vijay Co Operative Bank Limited',
	'VIJB' = 'VIJAYA BANK',
	'VSBL' = 'THE VISHWESHWAR SAHAKARI BANK LIMITED',
	'VVSB' = 'VASAI VIKAS SAHAKARI BANK LTD',
	'WBSC' = 'THE WEST BENGAL STATE COOPERATIVE BANK',
	'WPAC' = 'WESTPAC BANKING CORPORATION',
	'YESB' = 'YES BANK',
	'ZCBL' = 'THE ZOROASTRIAN COOPERATIVE BANK LIMITED',
	'ZSBL' = 'ZILA SAHAKRI BANK LIMITED GHAZIABAD'
}

export enum EDowntimeType {
	LOW = 'low',
	MEDIUM = 'medium',
	HIGH = 'high'
}

export enum EDowntimeFetchStatus {
	UPCOMING = 'UPCOMING',
	ONGOING = 'ONGOING',
	PAST = 'PAST'
}

export enum EDowntimeCreator {
	ZUPEE = 'zupee',
	RAZORPAY = 'razorpay',
	CASHFREE = 'cashfree'
}

export enum EAllInstrumentType {
	ALL = 'ALL'
}

export const DEFAULT_OPTIONS = [{ id: 'none', label: 'NONE' }];

export const FEATURE_TYPE_OPTIONS = [
	{ id: EFeatureType.PAYOUT, label: 'PAYOUT' },
	{ id: EFeatureType.CHECKOUT, label: 'DEPOSIT' }
];

export const PG_NAME_OPTIONS = [
	{ id: PaymentGateway.RAZORPAY, label: 'RAZORPAY' },
	{ id: PaymentGateway.CASHFREE, label: 'CASHFREE' },
	{ id: PaymentGateway.JUSPAY, label: 'JUSPAY' },
	{ id: PaymentGateway.PHONEPE, label: 'PHONEPE' },
	{ id: PaymentGateway.PAYU, label: 'PAYU' },
	{ id: PaymentGateway.RAZORPAY_V2, label: 'RAZORPAY V2' },
	{ id: PaymentGateway.CASHFREE_V2, label: 'CASHFREE V2' },
	{ id: PaymentGateway.CASHFREE_V3, label: 'CASHFREE V3' }
];

export const PAYMENT_MODE_CHECKOUT_OPTIONS = [
	{ id: EPaymentConfigModeType.cards, label: 'CARDS' },
	{ id: EPaymentConfigModeType.upi, label: 'UPI' },
	{ id: EPaymentConfigModeType.netbanking, label: 'Net Banking' },
	{ id: EPaymentConfigModeType.wallet, label: 'WALLET' }
];

export const PAYMENT_MODE_PAYOUT_OPTIONS = [
	{ id: EPayoutModeType.BANK, label: 'BANK' },
	{ id: EPayoutModeType.UPI, label: 'UPI' }
];

export const INSTRUMENT_TYPE_ALL_OPTIONS = [{ id: EAllInstrumentType.ALL, label: EAllInstrumentType.ALL }];

export const INSTRUMENT_TYPE_CHECKOUT_UPI_OPTIONS = [
	{ id: EUpiPaymentConfigInstrumentTypes.PHONE_PE, label: 'PHONE PE' },
	{ id: EUpiPaymentConfigInstrumentTypes.PAYTM_UPI, label: 'PAYTM UPI' },
	{ id: EUpiPaymentConfigInstrumentTypes.GOOGLE_PAY, label: 'GOOGLE PAY' },
	{ id: EUpiPaymentConfigInstrumentTypes.AMAZONE_PAY, label: 'AMAZONE PAY' },
	{ id: EUpiPaymentConfigInstrumentTypes.BHIM, label: 'BHIM' },
	{ id: EUpiPaymentConfigInstrumentTypes.AIRTEL, label: 'AIRTEL' },
	{ id: EUpiPaymentConfigInstrumentTypes.CRED, label: 'CRED' },
	...INSTRUMENT_TYPE_ALL_OPTIONS
];

export const INSTRUMENT_TYPE_CHECKOUT_WALLET_OPTIONS = [
	{ id: EWalletPaymentConfigInstrumentTypes.FREECHARGE, label: 'FREECHARGE' },
	{ id: EWalletPaymentConfigInstrumentTypes.PHONEPE, label: 'PHONE PE' },
	{ id: EWalletPaymentConfigInstrumentTypes.AMAZONPAY, label: 'AMAZON PAY' },
	{ id: EWalletPaymentConfigInstrumentTypes.OLAMONEY, label: 'OLA MONEY' },
	{ id: EWalletPaymentConfigInstrumentTypes.AIRTELMONEY, label: 'AIRTEL MONEY' },
	{ id: EWalletPaymentConfigInstrumentTypes.JIOMONEY, label: 'JIO MONEY' },
	{ id: EWalletPaymentConfigInstrumentTypes.MOBIKWIK, label: 'MOBIKWIK' },
	{ id: EWalletPaymentConfigInstrumentTypes.BAJAJPAY, label: 'BAJAJPAY' },
	...INSTRUMENT_TYPE_ALL_OPTIONS
];

export const INSTRUMENT_TYPE_CHECKOUT_NB_OPTIONS = [
	{ id: ENetBankingPaymentConfigInstrumentTypes.SBI, label: 'SBI' },
	{ id: ENetBankingPaymentConfigInstrumentTypes.KOTAK, label: 'KOTAK' },
	{ id: ENetBankingPaymentConfigInstrumentTypes.PNB, label: 'PNB' },
	{ id: ENetBankingPaymentConfigInstrumentTypes.YESB, label: 'YES BANK' },
	...INSTRUMENT_TYPE_ALL_OPTIONS
];

export const INSTRUMENT_CARD_TYPE_OPTIONS = [
	{ id: ECardType.CREDIT, label: 'CREDIT' },
	{ id: ECardType.DEBIT, label: 'DEBIT' },
	...INSTRUMENT_TYPE_ALL_OPTIONS
];

export const INSTRUMENT_NETWORK_OPTIONS = [
	{ id: ECardNetworkType.AMEX, label: 'AMEX' },
	{ id: ECardNetworkType.MAESTRO, label: 'MAESTRO' },
	{ id: ECardNetworkType.MASTERCARD, label: 'MASTERCARD' },
	{ id: ECardNetworkType.RUPAY, label: 'RUPAY' },
	{ id: ECardNetworkType.VISA, label: 'VISA' },
	...INSTRUMENT_TYPE_ALL_OPTIONS
];

export const INSTRUMENT_ISSUER_OPTIONS = Object.values(EBankIssuerTypes).map((value, ind) => {
	return { id: Object.keys(EBankIssuerTypes)[ind], label: value };
});

export const DOWNTIME_TYPE_OPTIONS = [
	{ id: EDowntimeType.HIGH, label: 'HIGH' },
	{ id: EDowntimeType.MEDIUM, label: 'MEDIUM' },
	{ id: EDowntimeType.LOW, label: 'LOW' }
];

export const SCHEDULE_OPTIONS = [
	{ id: EDowntimeFetchStatus.UPCOMING, label: 'UPCOMING' },
	{ id: EDowntimeFetchStatus.ONGOING, label: 'ONGOING' },
	{ id: EDowntimeFetchStatus.PAST, label: 'PAST' }
];

export const CREATOR_OPTIONS = [
	{ id: EDowntimeCreator.ZUPEE, label: 'ZUPEE' },
	{ id: EDowntimeCreator.CASHFREE, label: 'CASHFREE' },
	{ id: EDowntimeCreator.RAZORPAY, label: 'RAZORPAY' }
];

export type SDFilters = {
	startTime: number;
	schedule: EDowntimeFetchStatus;
	featureType: EFeatureType;
	paymentMode?: string;
	isActive?: boolean;
	createdBy?: boolean;
};

export type ContentPropsT = {
	handleFilterSubmit: (submittedFilters: SDFilters) => void;
	onClose: () => void;
};

export interface IDowntimeBaseInterface {
	constraintId: string;
	isActive: boolean;
	featureType: EFeatureType;
	paymentMode: EPayoutModeType | EPaymentConfigModeType;
	pgName: PaymentGateway;
	downtimeType: any;
	message: string;
	createdBy: EDowntimeCreator;
	emailId: string;
	createdAt?: number;
	updatedAt?: number;
	startTime: string;
	endTime: string;
	instrumentType: string;
	issuer: string;
	network: string;
	cardType: string;
}

export const defaultSDFilter = {
	startTime: Date.now(),
	schedule: EDowntimeFetchStatus.UPCOMING,
	featureType: EFeatureType.PAYOUT,
	isActive: true,
	paymentMode: EPayoutModeType.UPI
};

export const defaultSDCreate = {
	startTime: Date.now(),
	endTime: Date.now()
};

export const DOWNTIME_OPTIONS = [
	{ id: true, label: 'ACTIVE' },
	{ id: false, label: 'INACTIVE' }
];
